import { render } from "./PasswordDialog.vue?vue&type=template&id=9b2fa62a"
import script from "./PasswordDialog.vue?vue&type=script&lang=js"
export * from "./PasswordDialog.vue?vue&type=script&lang=js"

import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__